import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import {useEffect, useState} from "react";
import CustomTranslation from "core/customTranslation";

const translations = {
    es: {
        "load_type": "Se debe de seleccionar un tipo de carga y un tipo de residuo.",
    },
    en: {
        "load_type": "You must select a load type and a waste type.",
    },
};

const TabData = ({item, params, downloads, onChangeTypes, wastes}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tc} = useTranslation("choices");
    const {t: _TC} = CustomTranslation(translations);
    const [warning, setWarning] = useState(true);
    useEffect(() => {
        wastes.length && downloads.length
            ? setWarning(false)
            : setWarning(true);
    }, [wastes, downloads]);

    return (
        <>
            <div className="col-12">
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="uuid" className="col-form-label">
                            {_Tf("common.name")}
                        </label>
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            defaultValue={item.name}
                            required
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="description" className="col-form-label">
                            {_Tf("common.description")}
                        </label>
                    </div>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            defaultValue={item.description}
                        />
                    </div>
                </div>
                {warning ? (
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-12 text-center text-warning">
                            <FontAwesomeIcon
                                icon="triangle-exclamation"
                                className="text-warning"
                            />{" "}
                                {_TC("load_type")}
                        </div>
                    </div>
                ) : (
                    <></>
                )}

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-12 mt-5 text-center">
                        <h5>{_Tf("routes.type-download")}</h5>
                        {params.current.downloads.map((down, idx) => (
                            <Form.Check
                                type="checkbox"
                                className="d-inline-block me-3 mt-2"
                                key={idx}
                                name="download"
                                id={"download-" + down}
                                defaultValue={down}
                                label={_Tc("downloads." + down)}
                                checked={downloads.includes(down)}
                                onChange={onChangeTypes}
                            />
                        ))}
                    </div>
                    <div className="col-12 mt-5 text-center">
                        <h5>{_Tf("routes.type-waste")}</h5>
                        {params.current.wastes.map((wast, idx) => (
                            <Form.Check
                                type="checkbox"
                                className="d-inline-block me-3 mt-2"
                                key={idx}
                                name="waste"
                                id={"waste-" + wast}
                                defaultValue={wast}
                                label={_Tc("wastes." + wast)}
                                checked={wastes.includes(wast)}
                                readOnly={true}
                                onChange={onChangeTypes}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TabData;
